/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dur_HoursInputs */

const en_dur_hours = /** @type {(inputs: Dur_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hours`)
};

const he_dur_hours = /** @type {(inputs: Dur_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} שעות`)
};

/**
* | output |
* | --- |
* | "{count} hours" |
*
* @param {Dur_HoursInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const dur_hours = /** @type {((inputs: Dur_HoursInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dur_HoursInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dur_hours(inputs)
	return he_dur_hours(inputs)
});